import styled from 'styled-components';

export default styled.div`
  display: flex;
  font-size: 14px;
  justify-content: space-between;
  margin: 5px 0;
`;
